import axios from "axios";
import { router } from "../router";
import store from "./store";
import ml from "../ml";

export const logout = ({ commit, dispatch, state }) => {
  commit("clearUser")
  localStorage.removeItem("id")
  localStorage.removeItem("token")
  localStorage.removeItem("userName")
  localStorage.removeItem("email")
  localStorage.removeItem("companyName")
  localStorage.removeItem("profileUrl")
  localStorage.removeItem("title")
  localStorage.removeItem("defaultVisitorCardGroup")
  localStorage.removeItem("defaultFilters");
  localStorage.removeItem("authType");
  //localStorage.removeItem("lang")
  router.replace("/login");
}

export const initAuth = ({ commit, dispatch }) => {
  let id = localStorage.getItem("id");
  let token = localStorage.getItem("token");
  let userName = localStorage.getItem("userName");
  let eMail = localStorage.getItem("email");
  let companyName = localStorage.getItem("companyName");
  let title = localStorage.getItem("title");
  let profileUrl = localStorage.getItem("profileUrl");
  let defaultVisitorCardGroup = localStorage.getItem("defaultVisitorCardGroup");
  let language = localStorage.getItem("lang");
  let authType = localStorage.getItem("authType");
  let defaultFilters = JSON.parse(localStorage.getItem("defaultFilters"));
  commit("setUser", { id: id, userName: userName, mail: eMail, companyName: companyName, token: token, title: title, profileUrl: profileUrl, defaultVisitorCardGroup: defaultVisitorCardGroup, language: language, defaultFilters: defaultFilters, authType: authType })
  if (token) {
    //router.replace("/dashboard")
  } else {
    router.push("/login")//BURA AUTH OLACAK
    return false
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js